import * as Icons from "heroicons-react";
import { Image } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../../logo.svg";
import { signInUser } from "../../Utility/Auth";
import { resolvePhotoUrl } from "../../Utility/resolvePhotoUrl";
import { useSettingsQuery } from "../../../services/settingsApi";
import { getDisplayLogo } from "../../Utility/packageHelper";
import "./EcomSettingsSidebar.css";
import { IoBagCheckOutline } from "react-icons/io5";
import { RiShieldKeyholeLine } from "react-icons/ri";

const menuItems = [
  { name: "General Settings", key: "generalSettings", icon: <Icons.CogOutline size={20} /> },
  { name: "Banner Settings", key: "bannerSettings", icon: <Icons.PhotographOutline size={20} /> },
  { name: "Layout Settings", key: "layoutSettings", icon: <Icons.TemplateOutline size={20} /> },
  { name: "Typography Settings", key: "typographySettings", icon: <Icons.ClipboardListOutline size={20} /> },
  { name: "Header Setting", key: "headerSettings", icon: <Icons.ViewGridAddOutline size={20} /> },
  { name: "Footer Settings", key: "footerSettings", icon: <Icons.ViewListOutline size={20} /> },
  { name: "Product Page Settings", key: "productPageSettings", icon: <Icons.TagOutline size={20} /> },
  { name: "Checkout & Cart Settings", key: "checkoutCartSettings", icon: <IoBagCheckOutline size={20} /> },
  { name: "Partner API Settings", key: "partnerApiSettings", icon: <Icons.ServerOutline size={20} /> },
  { name: "API Keys", key: "apiKeySettings", icon: <RiShieldKeyholeLine size={20} /> },
];

const EcomSettingsSidebar = ({ active, setActive }) => {
  const auth = signInUser();
  const { aamarId, storeSettings } = auth || {};
  const { data: dbSettings } = useSettingsQuery(aamarId, { skip: !aamarId });
  const activeSettings = dbSettings || storeSettings;
  const storeLogoSrc = getDisplayLogo(auth, dbSettings, logo);
  const lang = useSelector((state) => state.languageReducer);

  return (
    <aside className="sticky-md-top ecom-sidebar ">
      <nav className="nav flex-column p-3 h-100">
        <Link to="/" className="text-center mb-4 d-flex justify-content-center align-items-center">
          <Image
            src={storeLogoSrc}
            alt="Logo"
            className="mx-auto d-block"
            style={{ maxWidth: "60%", maxHeight: "50px", objectFit: "contain" }}
            onError={(e) => {
              e.target.src = logo;
            }}
          />
        </Link>

        {menuItems.map((item) => (
          <div
            key={item.key}
            className={`sidebar-item d-flex align-items-center justify-content-between px-3 py-2 mb-2 rounded ${
              active === item.key ? "active" : ""
            }`}
            onClick={() => setActive(item.key)}
          >
            <div className="d-flex align-items-center">
              <span className="me-2">{item.icon}</span>
              <span className="sidebar-label">{item.name}</span>
            </div>
            <span>
              {active === item.key ? (
                <Icons.ChevronRightOutline size={16} />
              ) : (
                <Icons.ChevronDownOutline size={16} />
              )}
            </span>
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default EcomSettingsSidebar;
